<template>
  <div>
    <el-card class="box-card" body-style="padding:0px">
    <!-- 搜索栏   -->
    <div style="width: 100%">
      <el-input
          v-model="searchContent"
          placeholder="请输入查询内容"
          v-on:keyup.enter = "onSelect()"
          style="width: 100%"
      >
        <template #prepend>
          <el-select v-model="selectType" placeholder="选择类型" style="width: 115px">
            <el-option
                v-for="(value, key) in selectContent"
                :key="key"
                :label="value.label"
                :value="key"
            ></el-option>
          </el-select>
        </template>
        <template #append>
          <el-button icon="el-icon-search" @click="onSelect"/>
        </template>
      </el-input>
<!--      <el-select v-model="selectDataType" placeholder="选择类型" class="selectDataType">-->
<!--        <el-option-->
<!--            v-for="(value, key) in selectDataContent"-->
<!--            :key="key"-->
<!--            :label="value.label"-->
<!--            :value="key"-->
<!--        ></el-option>-->
<!--      </el-select>-->
      <div
          v-show="isDataUsrTree"
          style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 102;"
          @click="unPopDataSurTree">
      </div>
      <el-tree
          v-show="isDataUsrTree"
          :highlight-current = true
          :default-expand-all = false
          :expand-on-click-node="false"
          :data="dataTree"
          :props="defaultProps"
          node-key="data"
          accordion
          @node-click="selectChangeTree"
          class="module-pagetree"
          ref="datasurTree"
      >
        <template #default="scope">
            <span class="custom-tree-node" v-if="selectType==0">
              {{ scope.data.lable }}
            </span>
            <span class="custom-tree-node" v-if="selectType==1">
              {{ scope.data.data }}
            </span>
        </template>
      </el-tree>
    </div>
    <!-- 数据统计栏   -->
    <div class="data-statistics">
      <!-- 基础数据表格-->
      <el-tabs type="border-card">
        <el-tab-pane
            v-for="item in homeTableData[0].children"
            :key="item.idx"
            :label="item.name"
        >
          <div>
            <!-- 基础数据表格-->
            <el-table :data="item.tableData" v-loading="loading" border stripe height="calc(50vh - 138px)">
              <el-table-column
                  v-for="ite in item.children"
                  :prop="ite.idx"
                  :label="ite.name"
                  :key="ite.idx"
                  width="170">
                <template #default="scope">
                  <span
                      v-bind:class="{tableScope:!(scope.row[ite.idx]=='暂无数据' || scope.row[ite.idx]=='0' || ite.idx=='tableName' || scope.row[ite.idx]=='暂不统计')}"
                      @click.stop="drawingsClick(scope.row,ite)">
                    {{scope.row[ite.idx]}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 研究成果表格-->
      <el-tabs type="border-card" style="margin-top: 10px;height: 50%">
        <el-tab-pane
            v-for="item in homeTableData[1].children"
            :key="item.idx"
            :label="item.name"
        >
          <div>
            <!-- 研究成果表格-->
            <el-table :data="item.tableData" v-loading="loading" border stripe height="calc(50vh - 148px)">
<!--              <el-table-column-->
<!--                  v-for="ite in item.children"-->
<!--                  :prop="ite.idx"-->
<!--                  :label="ite.name"-->
<!--                  :key="ite.idx"-->
<!--                  width="170">-->
                <el-table-column
                    v-for="it in item.children"
                    :prop="it.idx"
                    :label="it.name"
                    :key="it.idx"
                    width="170">
                  <template #default="scope">
                  <span
                      v-bind:class="{tableScope:!(scope.row[it.idx]=='暂无数据' || scope.row[it.idx]=='0' || it.idx=='tableName'  )}"
                      @click.stop="drawingsClick(scope.row,it)">
                    {{scope.row[it.idx]}}
                  </span>
                  </template>
                </el-table-column>
<!--              </el-table-column>-->
            </el-table>

          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--数据成图栏    -->
<!--    <highchart v-loading="loading" ref="highchart" :id="chartData.id" :option="chartData.option" :chart-type="chartData.chartType" style="height: 300px" is-home-page="home"/>-->
    </el-card>
    <!--数据统计栏——表格弹窗    -->
    <div v-dialogDrag>
      <dialog-ex
          v-model="drawingsDialogVisible"
          :title="drillDlgTitle"
          width="90%"
          @closeMsg="drawingsDialogVisible = false"
          :is-footer="true">
        <template #body>
          <table-view v-if="drawingsDialogVisible" ref="tableview" :templateInfo="templateInfo" home-page-manager="true" home-checked-blk-id="curCheckedBlkId"></table-view>
        </template>
        <template #footer>
          <span class="dialog-footer">
              <el-button type="primary" @click="onCloseDrillDialog">退出</el-button>
          </span>
        </template>
      </dialog-ex>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import highchart from '../../components/Highchart'
import DialogEx from "@/components/dialogEx";
import tableView from "@/components/tableView";
//import {ref} from "vue";

export default {
  name: "homePageView",
  components:{
    highchart,
    DialogEx,
    tableView
  },
  data(){
    return{
      drawingsDialogVisible:false,
      loading:false,
      selectType:"0",//搜索类型
      selectContent: {
        "0": {
          label: "组合单元",
        },
        "1": {
          label: "单井",
        },
      },//搜索类型选项
      searchContent:"",//搜索栏内容
      selectDataType:"0",//搜索数据类型
      selectDataContent: {
        "0": {
          label: "基础数据",
        },
        "1": {
          label: "研究成果",
        },
      },//搜索数据类型选项
      isDataUsrTree: false,
      dataTree:[],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      homeTableData:[
        {
          "children":[
            {
              "idx":"",
              "name":"",
            }
          ]
        },
        {
          "children":[
            {
              "idx":"",
              "name":"",
            }
          ]
        }
      ],//数据统计——表头数据
      chartOption:{
        user_id: "0000001",
        user_empid: "EPLYTL110148104",
        // app_id: "3b5c693fda6d427c85d5586f0b3bb45a",
        app_id: "f3345b62cf0f44d6a05199bb4c603c4e",
        config_name:"",
        center_wells:["HD4-43"],//井组——中心井
        wells: ["DW105-192", "DW105-199"],//井组——关联井
        wellSingle:[],//单井——井名称信息
        time:null,
        legend:{
          verticalAlign:"top",
          floating:false,
          x:0,
          y:0,
          align:"right",
          enabled:true
        }
      },//获取曲线配置 参数
      chartData:{
        id: "chart_view",
        option: [],//chart的数据
        chartType: "normal",//chart的类型：normal、wellgroup
      },//曲线成图 参数

      drillDlgTitle:"详细信息",//弹出框标题
      templateInfo:{},//tableview组件参数
      curCheckedBlkId:"",//tableview组件 区块id
      WellTitles: [],//记录初始化的曲线标题名称
    }
  },
  mounted: function () {
    //获取最近一年的时间：年月
    let date = new Date();
    let dates = date.toLocaleDateString().split('/');
    if (dates[1].length == 1) {
      dates[1] = "0" + dates[1];
    }
    let dateStart = (dates[0]-1) + dates[1];
    let dateEnd = dates[0] + dates[1];
    console.log(dateStart,dateEnd);
    // this.chartOption.time=[dateStart,dateEnd];
    axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/queryheader", {
      chartOption: this.chartOption,
    }).then(res => {
      console.log("模块配置表数据信息:", res)
      // this.homeTableData = res.data.tableData;
      // let option=res.data.chartConfig.config;
      this.homeTableData=res.data.content.dataAll;
      //去除研究成果的多级表头，仅留叶子级表头
      if(this.homeTableData.length>1) {
        for(let idxa=0;idxa<this.homeTableData[1].children.length;idxa++){
          let item = this.homeTableData[1].children[idxa]
          if(item.children!=null && item.children.length>0) {
            let levChildren = [];
            for (let idxb=0;idxb<item.children.length;idxb++) {
              let ite = item.children[idxb]
              // console.log("item",item);
              if(ite.children!=null && ite.children.length>0) {
                for (let idxc=0;idxc<ite.children.length;idxc++) {
                  let it = ite.children[idxc]
                  levChildren.push(it);
                }
              }
              else{
                levChildren.push(ite);
              }
            }
            item.children = levChildren
          }
        }
      }
      // let option=res.data.content.chartConfig.config;
      // this.getWellTitles(option);
      // this.splicingWellTitle(option);
      // this.chartData.option = option;
    }).catch(err => {
      console.log(err);
    })

    //设置默认查询对象
    let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
    axios({
      url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/getuserOrgName?orgid="+lyqtUserInfo.belongOrgId,
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        if(res.data.orgName != null && res.data.orgName.length > 0 || res.data.orgName != "")
        {
          let data={};
          this.searchContent = "";
          switch (res.data.orgName){
            case "塔里木油田":
              this.searchContent = res.data.orgName;
              data={data: "塔里木油田",
                id: "GEUTTL100000320",
                lable: "塔里木油田",
                path: "塔里木油田",
                type: "BLOCK0"};
              break;
            case "东河采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "东河采油气管理区",
                id: "GEUTTL100000320",
                lable: "东河采油气管理区",
                path: "东河采油气管理区",
                type: "BLOCK1"};
              break;
            case "克拉采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "克拉采油气管理区",
                id: "GEUTTL100000320",
                lable: "克拉采油气管理区",
                path: "克拉采油气管理区",
                type: "BLOCK1"};
              break;
            case "博大采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "博大采油气管理区",
                id: "GEUTTL100000320",
                lable: "博大采油气管理区",
                path: "博大采油气管理区",
                type: "BLOCK1"};
              break;
            case "英买采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "英买采油气管理区",
                id: "GEUTTL100000320",
                lable: "英买采油气管理区",
                path: "英买采油气管理区",
                type: "BLOCK1"};
              break;
            case "迪那采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "迪那采油气管理区",
                id: "GEUTTL100000320",
                lable: "迪那采油气管理区",
                path: "迪那采油气管理区",
                type: "BLOCK1"};
              break;
            case "塔中采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "塔中采油气管理区",
                id: "GEUTTL100000320",
                lable: "塔中采油气管理区",
                path: "塔中采油气管理区",
                type: "BLOCK1"};
              break;
            case "泽普采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "泽普采油气管理区",
                id: "GEUTTL100000320",
                lable: "泽普采油气管理区",
                path: "泽普采油气管理区",
                type: "BLOCK1"};
              break;
            case "哈得采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "哈得采油气管理区",
                id: "GEUTTL100000320",
                lable: "哈得采油气管理区",
                path: "哈得采油气管理区",
                type: "BLOCK1"};
              break;
            case "轮南采油气管理区":
              this.searchContent = res.data.orgName;
              data={data: "轮南采油气管理区",
                id: "GEUTTL100000320",
                lable: "轮南采油气管理区",
                path: "轮南采油气管理区",
                type: "BLOCK1"};
              break;
          }

          if(this.searchContent.length>0) this.selectChangeTree(data);
        }
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  methods: {
    onCloseDrillDialog(){
      this.drawingsDialogVisible = false;
      // this.$refs.tableview.$destroy();
    },
    //点击搜索按钮
    onSelect() {
      this.dataTree = [];
      let blockType=localStorage.getItem("blockType");//获取研究对象类型
      if (blockType == null || blockType==undefined) blockType = "02";
      blockType = blockType.toString();
      this.isDataUsrTree = !this.isDataUsrTree;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/homeselect", {
        selectType: this.selectType,
        searchContent: this.searchContent,
        blockType:blockType,
        Authorization: "Bearer " + jwtSession,
      }).then(res => {
        this.dataTree = res.data.content;
        console.log("下拉框筛选数据：",this.dataTree);
      }).catch(err => {
        console.log(err)
      })
    },
    //数据来源下拉框展开时点击空白处关闭下拉框
    unPopDataSurTree() {
      this.isDataUsrTree = false;
    },
    //点击数据来源下拉框 选中 数据
    selectChangeTree(data){
      console.log(data);

      let blockList=[];
      if (data.type=="well"){
        blockList.push(data.data);
      }
      else if (data.type=="41"){
        blockList = [
          data.label,
          [],
          "qk",
          "02"
        ];
      }
      this.$store.state.wellDataHome = [];//清空vuex中的保存信息
      this.$store.state.wellDataHome = blockList;//将信息存入vuex中
      // this.$nextTick(()=>{
      //   this.$store.state.wellDataHome = [];//清空vuex中的保存信息
      // },100)

      this.loading=true;//添加加载效果
      this.searchContent=data.data;//将选中内容付给搜索框
      this.chartOption.wellSingle=[];//清空曲线单井名称数据
      this.chartOption.wellSingle.push(data.data);//将选中内容赋值给曲线单井
      this.dataTree=[];//清空下拉列表数据
      let blockType=localStorage.getItem("blockType");//获取研究对象类型
      if (blockType == null || blockType==undefined) blockType = "02";
      blockType = blockType.toString();
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/onselecthomepage", {
        selectType: this.selectType,
        searchContent: data,
        chartOption: this.chartOption,
        blockType:blockType,
      }).then(res => {
        console.log(res);
        this.homeTableData=res.data.content.dataAll;
        //去除研究成果的多级表头，仅留叶子级表头
        if(this.homeTableData.length>1) {
          for(let idxa=0;idxa<this.homeTableData[1].children.length;idxa++){
            let item = this.homeTableData[1].children[idxa]
            if(item.children!=null && item.children.length>0) {
              let levChildren = [];
              for (let idxb=0;idxb<item.children.length;idxb++) {
                let ite = item.children[idxb]
                // console.log("item",item);
                if(ite.children!=null && ite.children.length>0) {
                  for (let idxc=0;idxc<ite.children.length;idxc++) {
                    let it = ite.children[idxc]
                    levChildren.push(JSON.parse(JSON.stringify(it)));
                  }
                }
                else{
                  levChildren.push(JSON.parse(JSON.stringify(ite)));
                }
              }
              item.children = levChildren
            }
          }
        }
        // let option=res.data.content.chartConfig.config;
        // this.getWellTitles(option);
        // this.splicingWellTitle(option);
        // this.chartData.option=option;

        this.loading=false;
        console.log("封装表格数据的配置模板信息：",this.homeTableData);
      }).catch(err => {
        console.log(err)
      })
      this.isDataUsrTree=false;
    },
    //获取曲线标题的初始化名称
    getWellTitles(config) {
      this.WellTitles = [];
      for (let i = 0; i < config.length; i++) {
        let textName = config[i].title.text;
        textName = textName.replace("[对象]", "");//todo 为适配以前保存配置，替换对应字符
        this.WellTitles.push(textName);
      }
    },
    //曲线标题拼接井号
    splicingWellTitle(config) {
      //未勾选区块信息时，初始化加载，wells为空，暂不拼接；
      if (this.chartOption.wellSingle.length == 0)
        return
      for (let i = 0; i < config.length; i++) {
        if (this.chartData.chartType == "normal") {
          config[i].title.text = this.chartOption.wellSingle[0] + this.WellTitles[i];
        } else {
          if (i == 0)
            config[i].title.text = (this.chartOption.center_wells[0] != 0 ? this.chartOption.center_wells[0] : "") + this.WellTitles[0];
          else
            config[i].title.text = (this.chartOption.wells.length != 0 ? this.chartOption.wells[i - 1] : "") + this.WellTitles[1];
        }
      }
      return config;
    },

    //点击 数据统计栏 数据 时触发，显示弹窗框
    async drawingsClick(row,item){
      console.log(row)
      console.log(item)
      if(row[item.idx]=='暂无数据' || row[item.idx]=='0' || item.idx=="tableName"  || row[item.idx]=='暂不统计'){
        return;
      }
      let tmpInfo = {};
      tmpInfo.label=item.name;
      tmpInfo.modulename=item.name;
      tmpInfo.moduleid=item.moduleid;
      tmpInfo.type="table";
      await axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getpageid",{
        name:item.name,
        moduleid:item.moduleid
      }).then(res=>{
        console.log(res);
        tmpInfo.pageid=res.data;
        this.templateInfo=tmpInfo;
        this.drillDlgTitle=item.name;
        this.drawingsDialogVisible=true;
        this.$nextTick(() => {
          if (this.selectType == "0") {//区块
            this.$refs.tableview.$data.curCheckedBlkId = row.curCheckedBlkId;

            let qkObj = {};
            qkObj.type = 0;
            if (row.curCheckedBlkId instanceof Array)
              qkObj.value = row.curCheckedBlkId
            else
              qkObj.value = [row.curCheckedBlkId];
            console.log("qkobj1", qkObj)
            this.$store.state.isJump = true;
            this.$store.state.drillObj = qkObj;
            this.curCheckedBlkId=row.curCheckedBlkId;
          } else
          {
            let jhObj = {};
            jhObj.type = 1;
            jhObj.value = [{"id": row.curCheckedBlkId}];
            console.log("jhobj", jhObj)
            this.$refs.tableview.$data.curCheckedBlkId = "";
            this.$store.state.isJump = true;
            this.$store.state.drillObj = jhObj;
            this.curCheckedBlkId="";
          }
          console.log("tempInfo",this.templateInfo);
        })


      }).catch(err=>{
        console.log(err);
      })





    },

    //手动补全页面配置表的dataSID数据 todo 弃置
    completionDataSID(){
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/completiondatasid")
          .then(res => {
            console.log("信息：", res.data)
          })
    }
  },
  computed:{
    //计算单井数据变化
    wellDatas(){
      return this.$store.getters.getWellData;
    },
  },
  watch:{
    //监听单井数据变化
    wellDatas(){
      this.selectType = "1";

      let drillJH="";
      let wells = this.$store.state.wellData;
      console.log("homeWellDatas",wells)
      //用户第一次打开网站 缓存：localStorage为空
      if (wells!=null && wells!=undefined && wells.length!=4){
        drillJH=wells[0];//区块，或单井名称列表
        if (wells.length==3){
          drillJH=wells[1].toLocaleString();
        }
      }

      if(drillJH != "") {
        this.searchContent = drillJH;
        console.log(drillJH)
        let data = {
          data: drillJH,
          type: "well"
        };
        this.selectChangeTree(data);
      }
    },
  }
}
</script>

<style scoped>
.data-statistics{
  padding-top : 10px;
  /*padding-bottom : 10px;*/
  width: 100%;
  /*height: 400px;*/
  /*border-style: solid;*/
}
.selectDataType{
  float: right;
  width: 115px;
}
.module-pagetree {
  position: absolute;
  overflow: auto;
  width: calc(100% - 218px);
  height: auto;
  max-height : 200px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  opacity: 0.9;
  left: 138px;
}
.tableScope{
  cursor:pointer;
  color:blue
}
</style>